import React from 'react';
import {
  Navigation,
  HeroSection,
  AppsWeveBuiltSection,
  MercurySupportSection,
  Footer
} from '@/modules/landing';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gray-900">
      <Navigation />
      <HeroSection />
      <AppsWeveBuiltSection />
      <MercurySupportSection />
      <Footer />
    </div>
  );
}
